export default __webpack_public_path__ + "static/media/board_pack.6e5904f1.svg";